<template>
  <div class="content">
    <s-location apply title="오프라인증표 교환 신청"/>

    <h4 class="sub_title02">오프라인증표 교환 신청</h4>

      <div class="btn_group mt0">
        <div class="right">
          <button @click="doSearch" class="btn icon search_black">검색</button>
          <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
        </div>
      </div>
    <table class="tbl01 sch_tbl">
      <tr>
        <th>구입일</th>
        <td>
          <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_selldtfr" :placeholder="search.iv_selldtfr"/>
        ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_selldtto" :placeholder="search.iv_selldtto"/>
        </td>
      </tr>
      <tr>
        <th>증표 종류</th>
        <td  class="radio_inline">
          <c증표종류_검색폼 :search.sync="search" />
        </td>
      </tr>
      <tr>
        <th>증표 번호</th>
        <td>
            <input type="text" v-model="search.iv_rcptnofr_1" class="w_inputno" placeholder="증표번호 FROM"/> -
            <input type="text" v-model="search.iv_rcptnoto_1" class="w_inputno" placeholder="증표번호 TO" />
        </td>
      </tr>
      <tr>
        <th>검색어</th>
        <td>
          <select v-model="search.iv_ktype">
            <option value="ALL"      >전체</option>
            <option value="MEMBNM"   >증표명의</option>
            <option value="CLIENT"   >위임인</option>
            <option value="OTHERSIDE">상대방</option>
            <option value="REMK"     >비고</option>
          </select>
          <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색어" />
        </td>
      </tr>
    </table>

    <s-excel
      ref="excel"
      excel-api="/proc_excel/N_VIAINFO_SEL_LIST_EMP"
      excel-filename = "오프라인증표"
      :isDebug="false"
      :excel-top ="`

          조회기간 : ${ search.iv_selldtfr } ~ ${ search.iv_selldtto }

      `"
      excel-headers = "
          text           | value            | format
          구입일자       | selldt           | YYYY.MM.DD
          증표명의       | membnm           |
          증표종류       | org_caseclsfnm   |
          증표번호       | rcptno           | insertHyphen(5)
          비고           | remk             |
      "
      :excel-param = "()=>({
        ...search,
        iv_pgsize      : '-1',
        iv_page        : '1',
    })"/>

    <s-loading v-if="list.loading"/>
    <!-- 테이블 -->
    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <table class="tbl01">
        <thead>
          <tr>
            <th class="no" >순번</th>
            <th class="date">구입일자</th>
            <th class="vianame">증표명의</th>
            <th class="viakind">증표종류</th>
            <th class="viano">증표번호</th>
            <th>비고</th>
            <th class="btn01">추가</th>
          </tr>
        </thead>

        <tr v-for="(item,i) in list.items" :key=i>
          <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td v-html="T.nl_to_br(item.ownernm)"></td>
          <!-- <td>{{ item.caseclsfnm  }}</td> -->
          <td>{{ item.org_caseclsfnm  }}</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="al_l">{{ item.remk  }}</td>
          <!-- <td><a href="buy_receipt" class="btn xs gray01 outline">추가</a></td> -->
          <td class="p0">
            <img src="/images/common/icon_plus_blue.png"
                  class="icon_squ"
                  @click="addRow(item)">
          </td>
        </tr>
      </table>
     </div> <!--// scroll_wrap -->

    <!-- paging -->
    <div class="paging">
      <p class="num">
        <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
      </p>
    </div>
    <!-- /paging -->

    <h4 class="sub_title02">온라인으로 변경신청할 증표 현황</h4>
    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <table class="tbl01">
        <thead>
          <tr>
            <th class="no" >순번</th>
            <th class="day">구입일자</th>
            <th class="viakind">증표종류</th>
            <th class="viano">증표번호</th>
            <th>비고</th>
            <th class="btn01">제거</th>
          </tr>
        </thead>

        <tr v-for="(item,i) in saveList" :key=i>
          <td>{{ i + 1 }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <!-- <td>{{ item.caseclsfnm  }}</td> -->
          <td>{{ item.org_caseclsfnm  }}</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td class="al_l">{{ item.remk  }}</td>
          <!-- <td><a href="buy_receipt" class="btn xs gray01 outline">추가</a></td> -->
        <td class="p0">
          <img src="/images/common/icon_minus_org.png"
              class="icon_squ"
              @click="delRow(item)">
        </td>
      </tr>
      </table>
    </div> <!--// scroll_wrap -->

      <!-- //테이블 -->
      <!-- //변경내용 -->
      <div class="btn_group ">
        <button href="#"          class="btn gray01 outline left">취소</button>
        <button @click="saveItem" class="btn gray01 right">신청</button> <!-- href="buy_ok" -->
      </div>
	</div> <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
  components: {
    'c증표종류_검색폼'   : require('@/components/c증표종류_검색폼.vue').default
  },
   data () {
    return {
      search : {
        iv_menu         : 'ch_online'
      , iv_selldtfr     : this.$moment().add(-1, 'month').format("YYYY-MM-DD")
      , iv_selldtto     : this.$moment().format("YYYY-MM-DD")
      , iv_statclsf     : "BC0100"     // 미사용건만 출력
      , iv_viadtfr      : ""
      , iv_viadtto      : ""
      , iv_viaplac      : ""
      , iv_caseclsf     : ""
      , iv_rcptnofr_1   : ""
      , iv_rcptnoto_1   : ""
      , iv_rcptnofr     : ""
      , iv_rcptnoto     : ""
      , iv_cntchargdtfr : ""
      , iv_cntchargdtto : ""
      , iv_client       : ""
      , iv_isttoutplac  : ""
      , iv_otherside    : ""
      , iv_linkyn       : ""
      , iv_lostyn       : ""
      , iv_onlineyn     : "N" // 오프라인 증표만
      , iv_lawyernm     : ""
      , iv_membclsf     : ""
      , iv_membno       : ""
      , iv_membnm       : ""
      , iv_officeclsf   : ""
      , iv_officeno     : ""
      , iv_viamembclsf  : ""
      , iv_viamembno    : ""
      , iv_order_by1    : ""
      , iv_order_by2    : ""
      , iv_order_by3    : ""
      , iv_order_by4    : ""
      , iv_freeclsf     : ""
      , iv_case_b10300  : ""
      , iv_ktype        : "ALL"
      , iv_kword        : ""
      , iv_cancelclsf   : ""
      , iv_searchdtgbn  : ""
      , iv_searchfr     : ""
      , iv_searchto     : ""
      },
      sitem : {
        reasonclsf  : ''
      , reasonremk  : ''
      , to_membnm   : ''
      , to_membclsf : ''
      , to_membno   : ''
      , to_membaddr : ''
      },
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      saveList : [],

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
    }
  },
  created() {
    ui = this.$ui;
    this.search_init = { ...this.search }
  },
  mounted() {
    // 공통코드 로드
    this.doSearch()
  },
  methods : {
    addRow(item) {
      if (this.saveList.filter(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq).length > 0) {
        return ui.alert("이미 선택된 증표입니다. 선택 리스트를 확인해 주세요.")
      }

      this.saveList.push(item)
    },
    delRow(item) {
      this.saveList = this.saveList.filter(e => !(e.viaregdt == item.viaregdt && e.viaseq == item.viaseq))
    },
/*
    selectCust(item) {
      this.sitem.to_membclsf = item.membclsf
      this.sitem.to_membno   = item.membno
      this.sitem.to_membaddr = item.addr
    },
    initCust() {
      this.sitem.to_membclsf = ''
      this.sitem.to_membno   = ''
      this.sitem.to_membaddr = ''
    },
*/
    doSearch() {
      this.search.iv_rcptnofr = this.search.iv_rcptnofr_1 + "" + this.search.iv_rcptnoto_1
      this.search.iv_rcptnoto = this.search.iv_rcptnofr

      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })
    },
    saveItem() {
      if (this.saveList.length == 0) {
        return ui.alert("온라인으로 변경신청 할 증표를 추가해 주세요.")
      }

      ui.confirm('신청하시겠습니까 ?', "신청확인")
        .then(r => r && this.itemUpdate())
    },
    itemUpdate() {
      this.saveList.some((item, i) => {
        this.sitem.viaregdt = ((i == 0) ? '' : this.sitem.viaregdt + '#') + item.viaregdt
        this.sitem.viaseq   = ((i == 0) ? '' : this.sitem.viaseq   + '#') + item.viaseq
      })

/*
      // 변경 회원
      this.sitem.to_membclsf = this.sitem.to_membclsf || ''
      this.sitem.to_membno   = this.sitem.to_membno   || ''
*/

      ui.httpPost("/proc_iv/N_VIASTAT_UPD",
      {
        ...this.sitem
        , viastatclsf  : 'CH_ONLINE'
        , approveclsf  : 'REQ'
        , approvemsg   : ''
        , viastatdt    : ''
        , viastatseq   : ''
        , viastatdtlid : ''
        , caseclsf     : ''
        , to_caseclsf  : ''
        , to_casetype  : ''
        , to_viafee    : 0
        , to_amt       : 0
        , rf_amt       : 0
        , rfway        : ''
        , rfbankcode   : ''
        , remk         : ''
        , rfaccno      : ''
        , rfaccname    : ''
        , attachid     : ''
        , attachid2    : ''
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때 신청내역 페이지로 이동
           this.$router.push({ path: 'stat_list' })
        }

      })
    }
  }
}
</script>
